import React, { useState } from 'react'
import styled from 'styled-components'
import { CButton } from 'app/components/Common'
import AnnouncementCreateModal from './AnnouncementCreateModal'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const AnnouncementCreate = () => {
	const [showModal, setShowModal] = useState(false)

	return (
		<Wrapper>
			<CButton
				title="공지 등록"
				style={{
					background: 'linear-gradient(135deg, #5f76ff 0%, #7f8dff 100%)',
					color: '#ffffff',
					padding: '8px 20px',
					borderRadius: 999,
					fontWeight: 600,
					letterSpacing: 0.2,
					whiteSpace: 'nowrap',
				}}
				backgroundHover="linear-gradient(135deg, #7387ff 0%, #98a3ff 100%)"
				onClick={() => setShowModal(true)}
			/>
			<AnnouncementCreateModal
				showModal={showModal}
				setShowModal={setShowModal}
			/>
		</Wrapper>
	)
}

export default AnnouncementCreate
